import { Card, Table, Button, Pagination, Badge } from "react-bootstrap";
import { RiMapPinLine, RiSendPlane2Line, RiFileCopyLine } from "react-icons/ri";
import { useState } from "react";
import CustomPagination from "../../components/common/CustomPagination";
import { errorAlert, successAlert } from "../../components/common/Alert";
import { SendGateCodetoDriver } from "../../services/Networkcall";
import moment from "moment";
import { TbSend } from "react-icons/tb";
import Swal from "sweetalert2";


export default function GateCodesTable({ bookings, border=false,  pagination, pageHandler }) {

    const [sendingGateCode, setSendingGateCode] = useState(null);
    const [isTextCopied, setIsTextCopied] = useState(null);

    // ==================COPY GATE CODE=================
    const CopyGateCode = (gateCode, id) => {
        navigator.clipboard.writeText(gateCode);
        setIsTextCopied(id);
        setTimeout(() => {
            setIsTextCopied(null);
        }, 1000);
    };


    const getBookingStatus = (bookingDates) => {
        if (!bookingDates || bookingDates.length === 0) return "N/A";

        const now = moment.utc();
        const startDate = moment.utc(bookingDates[0]?.startDateTime);
        const endDate = moment.utc(bookingDates[bookingDates.length - 1]?.endDateTime);

        if (now.isAfter(endDate)) {
            return "Expired";
        } else if (now.isBefore(startDate)) {
            return "Upcoming";
        } else if (now.isBetween(startDate, endDate)) {
            const daysUntilExpiry = endDate.diff(now, "days");
            if (daysUntilExpiry <= 3) {
                return "Expiring Soon";
            }
            return "Active";
        }

        return "N/A";
    };


    const handleSendGateCode = async (id) => {
        setSendingGateCode(id);

        try {
            const result = await Swal.fire({
                title: "Send Gate Code?",
                text: "The driver will receive the gate code via email. Please confirm.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ok",
                cancelButtonText: "Cancel",
                dangerMode: true,
                customClass: {
                    popup: "custom-swal-popup",
                    title: "custom-swal-title",
                    htmlContainer: "custom-swal-text",
                    confirmButton: "custom-swal-confirm",
                    cancelButton: "custom-swal-cancel",
                },
            });

            if (!result.isConfirmed) return;

            const res = await SendGateCodetoDriver({ bookingId: id });
            if (res?.success) {
                successAlert({ message: res?.message || "Gate code sent to driver successfully" });
            } else {
                errorAlert({ message: res?.message || "Failed to send gate code to driver" });
            }
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to send gate code to driver" });
        } finally {
            setSendingGateCode(null);
        }
    };

    return (
        <Card className={`gc-table ${border ? "mt-3" : "border-0"}`}>

            {/* TABLE */}
            <div className="table-responsive">
                <Table hover>
                    <thead>
                        <tr>
                            <th>Gate Code</th>
                            <th>Driver</th>
                            <th>Truck / Plate</th>
                            <th>Yard</th>
                            <th>Reservation</th>
                            <th>Created</th>
                            <th>Expires</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {(bookings && bookings?.length > 0) ?
                            bookings.map((item, i) => (
                                <tr key={i}>

                                    {/* CODE */}
                                    <td data-label="Gate Code" className="gc-code text-primary">
                                        {!(item?.uniFiAccessPin) && 'processing...'}
                                        {item?.uniFiAccessPin}
                                        {item?.uniFiAccessPin && (
                                            <>
                                                <span className="position-relative d-inline-block">
                                                    <RiFileCopyLine className="cursor-pointer ms-2 mb-1" onClick={() => CopyGateCode(item?.uniFiAccessPin, item?._id)} />
                                                    {isTextCopied === item?._id && (
                                                        <span
                                                            className="position-absolute bottom-100 start-50 translate-middle-x mb-1 px-2 py-1 rounded bg-dark text-white"
                                                            style={{ fontSize: "0.75rem", whiteSpace: "nowrap", zIndex: 10 }}
                                                        >
                                                            Copied!
                                                        </span>
                                                    )}
                                                </span>
                                            </>
                                        )}
                                    </td>

                                    {/* DRIVER */}
                                    <td>
                                        <strong>{item?.driver?.userName || ""}</strong>
                                        <p className="mb-0">{item?.driver?.phoneNumber || ''}</p>
                                    </td>

                                    {/* TRUCK */}
                                    <td>
                                        <strong>{item?.vehicle_info?.vehicleName || ''}</strong>
                                        <p className="mb-0">{item?.vehicle_info?.licensePlate || ''}</p>
                                    </td>

                                    {/* YARD */}
                                    <td>
                                        <RiMapPinLine /> {item?.location_info?.locationName || ''}
                                    </td>

                                    <td data-label="Reservation">
                                        {item?.booking_dates && item?.booking_dates?.length > 0 && (
                                            <>
                                                <p className="mb-0">
                                                    {moment(item?.booking_dates[0]?.startDateTime).tz(item?.location_info?.location_timezone || moment.tz.guess())
                                                        .format("MMM DD, hh:mm A")} - </p>
                                                <p className="mb-0">{moment(item?.booking_dates[item?.booking_dates?.length - 1]?.endDateTime).tz(item?.location_info?.location_timezone || moment.tz.guess()).format("MMM DD, hh:mm A")}</p>
                                            </>
                                        )}
                                    </td>

                                    <td data-label="Created">
                                        {item?.createdAt ? moment(item?.createdAt).format("MMM DD, hh:mm A") : "N/A"}
                                    </td>

                                    <td data-label="Expires">
                                        {item?.booking_dates ? moment(item?.booking_dates[item?.booking_dates?.length - 1]?.endDateTime).tz(item?.location_info?.location_timezone || moment.tz.guess()).format("MMM DD, hh:mm A") : "N/A"}
                                    </td>

                                    {/* STATUS */}
                                    <td data-label="Status">
                                        <Badge
                                            className={` strong p-2 rounded-3
                                            gc-status fw-semibold
                                             ${getBookingStatus(item?.booking_dates) === "Active" ? "bg-success-subtle text-success" : ""}
                                             ${getBookingStatus(item?.booking_dates) === "Expired" ? "bg-danger-subtle text-danger" : ""}
                                              ${getBookingStatus(item?.booking_dates) === "Upcoming" ? "bg-primary-subtle text-primary" : ""}
                                              ${getBookingStatus(item?.booking_dates) === "Expiring Soon" ? "bg-warning-subtle text-warning" : ""}
                                        `}
                                        >
                                            {getBookingStatus(item?.booking_dates)}
                                        </Badge>
                                    </td>

                                    {/* ACTION */}
                                    <td>
                                        <Button
                                            variant={'primary'}
                                            size={'sm'}
                                            onClick={() => { handleSendGateCode(item?._id) }}
                                            disabled={sendingGateCode || item?.bookingType === 'ADMIN' || getBookingStatus(item?.booking_dates) === 'Expired' || item?.driver?.userName === "" || !item?.driver}>
                                            <TbSend /> {sendingGateCode === item?._id ? "Sending..." : "Send Gate Code"}
                                        </Button>
                                    </td>

                                </tr>
                            )) : (
                                <tr  >
                                    <td colSpan={12} className="text-center py-5">
                                        No bookings Found.
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </Table>
            </div>

            {/* PAGINATION */}
            <CustomPagination
                pagination={pagination}
                pageHandler={pageHandler}
            />

        </Card>
    );
}